import React from 'react';

import styled from 'styled-components';

import TemplatedText from './TemplatedText';
import QuestionErrorMessage from './QuestionErrorMessage';

import QuestionFormIntermezzo from './QuestionFormIntermezzo';
import QuestionFormNumber from './QuestionFormNumber';
import QuestionFormOptionMultiple from './QuestionFormOptionMultiple';
import QuestionFormOptionSingle from './QuestionFormOptionSingle';
import QuestionFormText from './QuestionFormText';
import { useLanguage } from './LanguageProvider';
import QuestionRedirect from './QuestionRedirect';
import QuestionFormNumberMultiple from './QuestionFormNumberMultiple';
import QuestionFormTextArea from './QuestionFormTextArea';
import QuestionFormTextMultiple from './QuestionFormTextMultiple';
import {Tooltip} from "../../components/Tooltip";
import {QuestionList} from "./QuestionList";

function questionFormFromType(type) {
  switch (type) {
    case 'QuestionTypeIntermezzo':
      return QuestionFormIntermezzo;
    case 'QuestionTypeNumber':
      return QuestionFormNumber;
    case 'QuestionTypeNumberMultiple':
      return QuestionFormNumberMultiple;
    case 'QuestionTypeOptionMultiple':
      return QuestionFormOptionMultiple;
    case 'QuestionTypeOptionSingle':
      return QuestionFormOptionSingle;
    case 'QuestionTypeText':
      return QuestionFormText;
    case 'QuestionTypeTextMultiple':
      return QuestionFormTextMultiple;
    case 'QuestionTypeTextArea':
      return QuestionFormTextArea;
    case 'QuestionTypeRedirect':
      return QuestionRedirect;
    case 'QuestionTypeList':
      return QuestionList;
    default:
      throw new Error(`Unknown question type '${type}'`);
  }
}

const QuestionBox = styled.div.attrs(() => ({
}))`
  max-width: 750px;
  position: relative;
  width: 750px;
`;

const Question = ({
  data,
  focus = false,
  show = true,
  variables = {},
  isOverview = false,
  validationError = null,
  onChangeCallback = (a, b, c, d, e) => {}
}) => {
  const language = useLanguage();

  const { key, text, description, type } = data;
  const QuestionForm = questionFormFromType(type);

  const onChange = (key, answer, validate, validateData) => {
    if(isOverview) {
        if(undefined === validateData) {
          validate(data, answer, language)
        } else {
          validate(data, validateData, language)
        }
        onChangeCallback(key, answer, validate, validateData, data)
    } else {
      onChangeCallback(key, answer, validate, validateData, data)
    }
  };

  return (
    <QuestionBox style={{display: show ? 'block' : 'none'}}>
      {
        data.infoText &&
        <Tooltip place={"top"} content={data.infoText}></Tooltip>
      }
      <div className="content is-medium" style={{marginRight: '35px'}}>
        <TemplatedText source={text} variables={variables} />
      </div>
      {description && (
        <div className="notification">
          <div className="content">
            <TemplatedText source={description} variables={variables} />
          </div>
        </div>
      )}
      <QuestionForm
        focus={focus}
        question={data}
        show={show}
        savedAnswer={variables[key]}
        variables={variables}
        onChange={onChange}
      >
      </QuestionForm>
      <QuestionErrorMessage error={validationError}/>
    </QuestionBox>
  );
};

export default Question;
